/*
 * Module for handling the status of a topic
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicStatus/topicStatusView",
  "modules/topicsSplit/topic/topicPublishModal/topicPublishModalModule",
  "modules/topicsSplit/topic/topicDisableModal/topicDisableModalModule",
  "modules/header/kbMenu/kbMenuModel",
  "modules/topicsSplit/topic/topicEnableModal/topicEnableModalModule",
], function (
  Marionette,
  Backbone,
  _,
  Messenger,
  TopicStatusView,
  TopicPublishModalModule,
  TopicDisableModalModule,
  KbMenuModel,
  TopicEnableModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicStatus";
      this.region = options.region;
      this._setUpVents();
    },
    show: function (topic) {
      const _this = this;
      this.statuses = Messenger.reqres.request("kb:statuses");
      this.topic = topic;
      topic.allowEditTopicStatus = Messenger.reqres.request("can:edit:topicStatus");
      this.view = new TopicStatusView.topicStatusesView({ model: topic }); //set collection later, since we need to do
      // some processing on statuses
      this.view.on(
        "itemview:select:status",
        function (itemView) {
          const newStatusId = itemView.model.get("targetStatusId");
          //if status is now published, fire a save to save the topic and publish the conversation
          if (newStatusId === KbMenuModel.statuses.VERSIONED_PUBLISHED) {
            //user selected "Publish...", open the modal to select the pending responses to publish
            if (itemView.model.get("transitionName") === "topic.statuses.publishSelected") {
              Messenger.vent.trigger("show:modal", TopicPublishModalModule, {}, topic, {
                title: "topic.publish.title",
                closeOnBackgroundClick: false,
                modalWidth: 550,
                trackInteraction: {
                  action: "Topic Publish Selected",
                  id: topic.id,
                  idType: "Topic",
                  object: "Topic",
                },
              });
            } else {
              // Publish All
              //delete after user confirmation
              Messenger.yesNoDialog(
                "topic.dialog.publishAll",
                {
                  yes: function () {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Publish Responses",
                      id: _this.topic.id,
                      idType: "Topic",
                      object: "Topic",
                    });
                    //keep track of old status in case of save failure
                    const oldStatusId = _this.topic.getStatus();
                    const liveConversation = topic.liveConversation(false);
                    liveConversation.publishAll = true;
                    liveConversation.needToPublish = true;
                    this._updateStatus(newStatusId);
                    Messenger.save(function (success) {
                      //if success
                      if (success) {
                        this._pickStatusTransitions();
                        Messenger.vent.trigger("published:responses:locale:dropdown:refresh");
                      } else {
                        //if failure, rollback to previous status
                        this._updateStatus(oldStatusId);
                      }
                    }, this);
                  },
                  no: function () {
                    Messenger.vent.trigger("cancel:pending:responses");
                  },
                },
                this,
              );
            }
          } else if (
            newStatusId === KbMenuModel.statuses.VERSIONED_DISABLED ||
            newStatusId == KbMenuModel.statuses.NON_VERSIONED_DISABLED
          ) {
            // Disabled
            //user selected "Disable...", open the modal to select the responses to disable
            if (itemView.model.get("transitionName") === "topic.statuses.disableSelected") {
              Messenger.vent.trigger("show:modal", TopicDisableModalModule, {}, topic, {
                title: "topic.disable.title",
                closeOnBackgroundClick: false,
                modalWidth: 550,
                trackInteraction: {
                  action: "Topic Disable Selected",
                  id: topic.id,
                  idType: "Topic",
                  object: "Topic",
                },
              });
            } else {
              // Disable All
              Messenger.yesNoDialog(
                "topic.dialog.disable",
                {
                  yes: function () {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Disable Responses",
                      id: _this.topic.id,
                      idType: "Topic",
                      object: "Topic",
                    });
                    //keep track of old status in case of save failure
                    const oldStatusId = _this.topic.getStatus();
                    const conversation = _this.topic.conversation();
                    conversation.disableAll = true;
                    conversation.needToDisable = true;
                    this._updateStatus(newStatusId);
                    Messenger.save(function (success) {
                      //if success
                      if (success) {
                        this._pickStatusTransitions();
                        Messenger.vent.trigger("published:responses:locale:dropdown:refresh");
                      } else {
                        //if failure, rollback to previous status
                        this._updateStatus(oldStatusId);
                      }
                    }, this);
                  },
                  no: function () {
                    Messenger.vent.trigger("cancel:disable:responses");
                  },
                },
                this,
              );
            }
          } else if (newStatusId === KbMenuModel.statuses.NON_VERSIONED_ENABLED) {
            // Enabled
            //user selected "Enable...", open the modal to select the responses to disable
            if (itemView.model.get("transitionName") === "topic.statuses.enableSelected") {
              Messenger.vent.trigger("show:modal", TopicEnableModalModule, {}, topic, {
                title: "topic.enable.title",
                closeOnBackgroundClick: false,
                modalWidth: 550,
                trackInteraction: {
                  action: "Topic Enable Selected",
                  id: topic.id,
                  idType: "Topic",
                  object: "Topic",
                },
              });
            } else {
              // Enable All
              Messenger.yesNoDialog(
                "topic.dialog.enable",
                {
                  yes: function () {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Enable Responses",
                      id: _this.topic.id,
                      idType: "Topic",
                      object: "Topic",
                    });
                    //keep track of old status in case of save failure
                    const oldStatusId = _this.topic.getStatus();
                    const conversation = _this.topic.conversation();
                    conversation.enableAll = true;
                    conversation.needToEnable = true;
                    this._updateStatus(newStatusId);
                    Messenger.save(function (success) {
                      //if success
                      if (success) {
                        this._pickStatusTransitions();
                        Messenger.vent.trigger("published:responses:locale:dropdown:refresh");
                      } else {
                        //if failure, rollback to previous status
                        this._updateStatus(oldStatusId);
                      }
                    }, this);
                  },
                  no: function () {
                    Messenger.vent.trigger("cancel:enable:responses");
                  },
                },
                this,
              );
            }
          }
        },
        this,
      );
      //handle setting the selected status in the view (need to manage the loading of two async calls)
      this.topic.onSynced(function () {
        this._pickStatusTransitions();
      }, this);
      this.showRegion(this.view);
    },
    _pickStatusTransitions: function () {
      //decide the possible transitions from this status and rerender the view
      Messenger.reqres.request("topic:statuses", this.topic).then((transitions) => {
        this.view.collection = transitions;
        //trigger event that the status was set
        Messenger.vent.trigger("set:topic:status", this.topic.getStatus());
        this.view.render();
      });
    },
    _updateStatus: function (statusId) {
      //update the status of the topic
      this.statuses.onSynced(function () {
        const statusArray = this.statuses.get("allTopicStatuses");
        for (let i = 0; i < statusArray.length; i++) {
          if (statusArray[i].statusId === statusId) {
            this.topic.setStatus(statusId);
            break;
          }
        }
      }, this);
    },
    _setUpVents: function () {
      const _this = this;
      Messenger.vent.on(
        "topic:response:changed",
        function () {
          //when response versioning is enabled and the current status is 'published', then change to 'pending-response'
          const kb = Messenger.reqres.request("active:kb:model");
          kb.onSynced(function () {
            if (
              kb.get("responseVersioning") &&
              (this.topic.getStatus() == KbMenuModel.statuses.VERSIONED_PUBLISHED ||
                this.topic.getStatus() == KbMenuModel.statuses.VERSIONED_DISABLED)
            ) {
              this._updateStatus(KbMenuModel.statuses.VERSIONED_PENDING_RESPONSE);
              this._pickStatusTransitions();
            }
          }, this);
        },
        this,
      );
      Messenger.vent.on(
        "publish:pending:responses",
        function () {
          //keep track of old status in case of save failure
          const oldStatusId = this.topic.getStatus();
          _this.topic.liveConversation(false).needToPublish = true;
          Messenger.save(function (success) {
            //if success
            if (success) {
              this._pickStatusTransitions();
              Messenger.vent.trigger("published:responses:locale:dropdown:refresh");
            } else {
              //if failure, rollback to previous status
              this._updateStatus(oldStatusId);
            }
          }, this);
        },
        this,
      );
      Messenger.vent.on("disable:selected:responses", function () {
        //keep track of old status in case of save failure
        const oldStatusId = _this.topic.getStatus();
        _this.topic.conversation().needToDisable = true;
        Messenger.save(function (success) {
          if (success) {
            _this._pickStatusTransitions();
            Messenger.vent.trigger("published:responses:locale:dropdown:refresh");
          } else {
            //if failure, rollback to previous status
            _this._updateStatus(oldStatusId);
          }
        });
      });
      Messenger.vent.on("enable:selected:responses", function () {
        //keep track of old status in case of save failure
        const oldStatusId = _this.topic.getStatus();
        _this.topic.conversation().needToEnable = true;
        Messenger.save(function (success) {
          if (success) {
            _this._pickStatusTransitions();
            Messenger.vent.trigger("published:responses:locale:dropdown:refresh");
          } else {
            //if failure, rollback to previous status
            _this._updateStatus(oldStatusId);
          }
        });
      });
      Messenger.vent.on(
        "cancel:pending:responses",
        function () {
          //if the user cancels the "Publish Responses" modal, close the topic status drop-down
          this.view.render();
        },
        this,
      );
      Messenger.vent.on(
        "cancel:disable:responses",
        function () {
          //if the user cancels the "Disable Responses" modal, close the topic status drop-down
          this.view.render();
        },
        this,
      );
      Messenger.vent.on(
        "cancel:enable:responses",
        function () {
          //if the user cancels the "Enable Responses" modal, close the topic status drop-down
          this.view.render();
        },
        this,
      );

      Messenger.reqres.setHandler("get:topic:status", () => this.topic.getStatus());
    },
  });
});
